export default "__VITE_ASSET__DXxsC362__"